var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loaded
    ? _c("div", { staticClass: "t-hosted" }, [
        _c("div", { staticClass: "t-hosted__header" }, [
          _c("div", { staticClass: "t-hosted__grow" }, [
            _vm.workspace.logo
              ? _c("img", {
                  attrs: { src: _vm.workspace.logo, height: "30px" },
                })
              : _c(
                  "a",
                  { attrs: { href: "https://trainn.co/", target: "_blank" } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/lib/assets/images/trainn-logo-black.svg"),
                        height: "20px",
                        alt: "Customer Education Platform",
                      },
                    }),
                  ]
                ),
          ]),
          _vm._v(" "),
          _vm.brandingMode == "strong_mode" && !_vm.$isMobile
            ? _c("div", { staticClass: "t-hosted__aside" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "cta",
                    attrs: { href: "https://app.trainn.co/sign_up" },
                  },
                  [_vm._v("\n        Try Trainn for Free\n      ")]
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "t-hosted__wrapper" }, [
          !_vm.$isEmpty(_vm.videoList) &&
          !_vm.$isEmpty(_vm.videoList[_vm.currentIndex])
            ? _c("div", { staticClass: "t-hosted__breadcrumb" }, [
                _c("div", { staticClass: "t-flex t-flex--aic" }, [
                  _c("i", {
                    staticClass:
                      "mdi mdi-play-box-outline mdi-21px t-mar--r-mi",
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.videoList[_vm.currentIndex].title || "---") +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.checkduration
                  ? _c("div", { staticClass: "t-flex t-flex--aic" }, [
                      _c("i", {
                        staticClass:
                          "mdi mdi-clock-outline mdi-21px t-mar--r-mi",
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$msToTime(
                                _vm.videoList[_vm.currentIndex].publishedVersion
                                  .duration * 1000
                              )
                            ) +
                            "\n          mins"
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "t-hosted__content" },
            [
              !_vm.$isEmpty(_vm.videoList) &&
              !_vm.$isEmpty(_vm.videoList[_vm.currentIndex])
                ? [
                    _c(
                      "div",
                      {
                        key: "player",
                        staticClass:
                          "t-vplayer t-mar--l-auto t-mar--r-auto share",
                      },
                      [
                        !_vm.$isEmpty(
                          _vm.videoList[_vm.currentIndex].accessUrl
                        ) || _vm.videoList[_vm.currentIndex].deleted
                          ? [
                              !_vm.$isEmpty(
                                _vm.videoList[_vm.currentIndex].accessUrl
                              )
                                ? _c("video-player", {
                                    key: `video_${_vm.currentIndex}`,
                                    attrs: {
                                      video: _vm.videoList[_vm.currentIndex],
                                      poster:
                                        _vm.videoList[_vm.currentIndex].url,
                                    },
                                    on: {
                                      video_loaded: function ($event) {
                                        return _vm.startTracker(
                                          _vm.videoList[_vm.currentIndex]
                                        )
                                      },
                                    },
                                  })
                                : _vm.videoList[_vm.currentIndex].deleted
                                ? _c("video-not-available", {
                                    key: "video-not-found",
                                  })
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "t-hosted__main t-mar--t-md" },
                      [
                        _vm.videoList[_vm.currentIndex].createdBy ||
                        _vm.videoList[_vm.currentIndex].createdAt
                          ? [
                              _c("div", { staticClass: "t-hosted__card" }, [
                                _c("div", { staticClass: "t-creator" }, [
                                  _vm.videoList[_vm.currentIndex].createdBy
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "t-creator__avatar t-mar--r-mi",
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.videoList[
                                                  _vm.currentIndex
                                                ].createdBy.charAt(0)
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "t-creator__details" },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.videoList[_vm.currentIndex]
                                                .createdBy
                                            ) +
                                            "\n                  "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.videoList[_vm.currentIndex].createdAt
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                    Updated on\n                    " +
                                                _vm._s(
                                                  _vm.$dateFromUTC(
                                                    _vm.videoList[
                                                      _vm.currentIndex
                                                    ].createdAt
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "t-feedback" },
                                  [
                                    _c(
                                      "t-button",
                                      {
                                        class: {
                                          active:
                                            _vm.userFeedback.satisfaction ==
                                            "love",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.satisfaction(
                                              _vm.videoList[_vm.currentIndex],
                                              "love"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  ❤️\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "t-button",
                                      {
                                        class: {
                                          active:
                                            _vm.userFeedback.satisfaction ==
                                            "happy",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.satisfaction(
                                              _vm.videoList[_vm.currentIndex],
                                              "happy"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  🤩\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "t-button",
                                      {
                                        class: {
                                          active:
                                            _vm.userFeedback.satisfaction ==
                                            "thumbs_up",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.satisfaction(
                                              _vm.videoList[_vm.currentIndex],
                                              "thumbs_up"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  👍\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "t-button",
                                      {
                                        class: {
                                          active:
                                            _vm.userFeedback.satisfaction ==
                                            "thumbs_down",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.satisfaction(
                                              _vm.videoList[_vm.currentIndex],
                                              "thumbs_down"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  👎\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "t-button",
                                      {
                                        class: {
                                          active:
                                            _vm.userFeedback.satisfaction ==
                                            "angry",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.satisfaction(
                                              _vm.videoList[_vm.currentIndex],
                                              "angry"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  😡\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.videoList[_vm.currentIndex].publishedVersion &&
                        _vm.videoList[_vm.currentIndex].publishedVersion
                          .description
                          ? _c(
                              "div",
                              { staticClass: "t-hosted__description" },
                              [
                                _c("h4", [_vm._v("Description")]),
                                _vm._v(" "),
                                _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.videoList[_vm.currentIndex]
                                        .publishedVersion.description
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                : _vm.videoInAccessible
                ? _c(
                    "div",
                    { staticClass: "t-vplayer t-mar--l-auto t-mar--r-auto" },
                    [
                      _c("video-not-available", {
                        attrs: { type: "link", code: _vm.errorCode },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.brandingMode != "disabled"
            ? _c("div", { staticClass: "t-hosted__brand" }, [_vm._m(1)])
            : _vm._e(),
        ]),
      ])
    : _c("PageLoader", {
        key: "loader",
        staticClass: "t-mar--t-xxl t-flex--jcc",
        attrs: { spinner: _vm.brandingMode == "disabled" },
      })
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "t-tc--primary t-mar--r-xs",
        attrs: { href: "https://trainn.co/" },
      },
      [
        _vm._v("\n        Powered by "),
        _c("b", [_vm._v("Trainn")]),
        _vm._v(": The All-in-One Customer Education Platform\n      "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { attrs: { href: "https://trainn.co/", target: "_blank" } },
      [
        _c("img", {
          staticClass: "t-mar--r-mi",
          attrs: {
            src: require("@/lib/assets/images/Trainn-Logo-Assets/trainn-grey-flame.svg"),
            height: "18px",
          },
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Powered by "), _c("b", [_vm._v(" Trainn")])]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }